<template>
  <div class="subject-index">
    <div class="subject-box">
      <div class="subject-index-content">
        <div class="left" v-if="moduleList.length">

          <el-tree :data="moduleList" node-key="id" default-expand-all :expand-on-click-node="true" :props="defaultProps" @node-click="nodeClick">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <div style="flex: 1;text-indent: 1em;">{{ node.label }}</div>
              <div class="el-icon-arrow-right" :class="{'has-child': data.children.length}"></div>
            </span>
          </el-tree>


        </div>
        <div class="right">
          <div class="head">
            <el-menu :default-active="navIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="1">最新</el-menu-item>
              <el-menu-item index="2">价格</el-menu-item>
              <el-menu-item index="3">销量</el-menu-item>
            </el-menu>
            <el-input placeholder="请输入内容" v-model="queryParams.name" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
            </el-input>
          </div>
          <div class="goods-content">
            <booklist-box :data-list="bookList"></booklist-box>
            <noData v-if="total == 0"></noData>
            <div class="pagination-box" v-show="total > 0">
              <el-pagination
                  class="ou-pagination"
                  background
                  hide-on-single-page
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-sizes="[10, 20, 30, 40, 50]"
                  :page-size="queryParams.pageSize"
                  layout="total, prev, pager, next, sizes, jumper, slot"
                  :total="total"
              >
                <el-button @click="getList()" class="ou-page-go">GO</el-button>
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import booklistBox from "@/components/booklistBox.vue";
import noData from "@/components/noData.vue";
import {getClassResourcesList,getClassList} from "@/api/bookstore/bookstore";
export default {
  data() {
    return {
      moduleList:[],
      defaultProps: {
        children: 'children',
        label: 'moduleName'
      },
      activeIndex: '1',
      total:0,
      radio1: null,
      navIndex: '1',
      bookList: [],
      queryParams: {
        catalogId: '1701490778171379712',
        pageNum: 1,
        pageSize: 10,
        level:0,
        name: ''
      },
    }
  },
  components: { booklistBox,noData },
  watch: {
    //监听
    $route(to, from) {
      //路由变化方式，当路由跳转到书城列表时，方法就会执行
      if (to.path == "/subjectClassification/index") {
        this.getList();
      }
    }
  },
  created() {
    getClassList({platform:'custom'}).then(res=>{
      this.moduleList = res.rows
    })
    // this.getList()
  },
  methods: {
    handleSelect(){},
    search(){
      this.queryParams.pageNum = 1
      this.getList()
    },
    nodeClick(a,b,c){
      console.log(a, b, c);
      this.queryParams.catalogId = a.id
      this.queryParams.level = b.level
      this.getList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    getList() {
      getClassResourcesList(this.queryParams).then(res => {
        if (res.code == 200) {
          this.bookList = res.rows;
          this.total = res.total;
        }
      });
    },
  }
};
</script>
<style scoped lang="scss">
.subject-index{
  width: 100%;
  background-color: #f7f7f7;
  overflow: hidden;
  .subject-box{
    width: 1400px;
    margin: 30px auto 50px;
    .subject-index-content{
      display: flex;
      justify-content: space-between;
      .left{
        width: 300px;
        height: max-content;
        padding: 12px 5px 14px 26px;
        background-color: #fff;
        box-sizing: border-box;
        .el-collapse-item{
          margin-bottom: 30px;
          ::v-deep .el-collapse-item__content{
            padding-bottom: 0;
          }
          ::v-deep.el-collapse-item__header{
            border-left: 6px solid #128bff;
            text-indent: 10px;
            font-size: 20px;
            background-color: #e5e5e5;
          }
        }
        .el-radio-group{
          display: block;
          width: 96%;
          margin:  0 auto;

          .el-radio{
            display: flex;
            align-items: center;
            line-height: 48px;
            border-bottom: 1px solid #e5e5e5;
            margin-right: 0;
            ::v-deep.el-radio__inner{
              border-radius: 1px;
              width: 10px;
              height: 10px;
              &:after{
                display: none;
              }
            }
            ::v-deep.el-radio__label{
              font-size: 18px;
              padding-left: 8px;
            }
          }
        }
      }
      .right{
        background-color: #fff;
        width: 1090px;
        border: 1px solid #e5e5e5;
        height: max-content;
        .head{
          padding: 0 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #e5e5e5;
          ::v-deep.el-menu{
            &.el-menu--horizontal{
              border-bottom:1px solid transparent;
            }
            .el-menu-item{
              height: 50px;
              line-height: 50px;
              font-size: 20px;
              padding: 0 10px;
              &.is-active{
                border-bottom-width: 4px;
                color: #409EFF;
              }
            }
          }
          .el-input{
            width: 300px;
            height: 34px;
            ::v-deep .el-input__inner{
              height: 34px;
              border-radius: 0;
              line-height: 34px;
            }
            ::v-deep .el-button{
              padding: 10px 10px!important;
              background-color: #128bff;
              color: #fff;
              border-radius: 0;
              border: none;
            }
          }
        }
        .goods-content{
          padding: 0 13px;
          .goods-item{
            border-bottom: 1px solid #e5e5e5;
            display: flex;
            padding: 29px 0;
            img{

            }
            .des{
              margin-left: 22px;
              .h{
                display: flex;
                .title{
                  font-size: 24px;
                }
              }
            }
          }
        }
      }
    }
  }
}
.pagination-box {
  text-align: right;
  margin: 25px 0;
}

.el-submenu.is-active{
  background-color: #ecf5ff;
}
::v-deep .el-tree-node__content{
  width: 100%;
  box-sizing: border-box;
  padding: 25px 0;
  .custom-tree-node{
    display: flex;
    width: 100%;
    align-items: center;
    .el-icon-arrow-right{
      text-align: right;
      display: none;
      text-indent: 1em;
      &.has-child{
        display: block;
      }
    }
  }
}
::v-deep .el-tree-node__expand-icon{
  display: none;
}
.is-expanded{
  & > .el-tree-node__content{
    .el-icon-arrow-right{
      transform: rotate(90deg);
    }
  }
}

</style>
